import * as THREE from 'three'

import Experience from '../Experience.js'

import Environment from './Environment.js'
import Sphere from './Sphere.js'
import Vortex from './Vortex.js'

export default class World {
  constructor () {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.camera = this.experience.camera
    this.raycaster = this.experience.raycaster
    this.sizes = this.experience.sizes

    this.sphere1 = new Sphere(-20, -42, -400, '0')
    this.sphere2 = new Sphere(300, 60, 0, '1')
    this.sphere3 = new Sphere(-174, 236, 297, '2')

    this.spheres = [this.sphere1, this.sphere2, this.sphere3]

    // this.PointLight = new PointLight(this.Sphere.mesh.position);
    // console.log(this.Sphere.mesh.position)
    this.currentIntersect0 = null
    this.currentIntersect1 = null
    this.currentIntersect2 = null

    this.onClickDetect()
    this.onMouseHover()
    // Wait for resources
    this.resources.on('ready', () => {
      // Setup
      this.environment = new Environment()
      this.vortex = new Vortex(this.spheres)
    })
    this.environment = new Environment()
    this.vortex = new Vortex(this.spheres)
  }

  onClickDetect = () => {
    window.addEventListener('click', (event) => {
      this.mouse = new THREE.Vector2(0, 0)
      this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1
      this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1
      this.raycaster.setFromCamera(this.mouse, this.camera.instance)

      const objectsToTest = [
        this.sphere1.mesh,
        this.sphere2.mesh,
        this.sphere3.mesh
      ]
      const intersects = this.raycaster.intersectObjects(objectsToTest)

      for (let i = 0; i < intersects.length; i++) {
        intersects[i].object.material.color.set(0x000000)
        // In de l'overlay en fonction de la sphere
        document.querySelector(`.overlay-${intersects[0].object.name}`).style.display = 'block'
        document.querySelector(`.overlay-${intersects[0].object.name}`).style.animationName = 'slidein'

        // Close de l'overlay en fonctio nde la sphere
        document.querySelector(`.overlay__close-${intersects[0].object.name}`).addEventListener('click', () => {
          console.log('close')
          document.querySelector(`.overlay-${intersects[0].object.name}`).style.animationName = 'slideout'
          setTimeout(() => {
            this.sizes.trigger('nextAnimation')
            document.querySelector(`.overlay-${intersects[0].object.name}`).style.display = 'none'
          }, 2000)
        })
      }
    })
  };

  onMouseHover = () => {
    window.addEventListener('mousemove', (e) => {
      this.mouse = new THREE.Vector2(0, 0)
      this.mouse.x = (e.clientX / this.sizes.width) * 2 - 1
      this.mouse.y = -(e.clientY / this.sizes.height) * 2 + 1
      this.raycaster.setFromCamera(this.mouse, this.camera.instance)

      const objectsToTest0 = [
        this.sphere1.mesh
      ]
      const objectsToTest1 = [
        this.sphere2.mesh
      ]
      const objectsToTest2 = [
        this.sphere3.mesh
      ]
      const intersects0 = this.raycaster.intersectObjects(objectsToTest0)
      const intersects1 = this.raycaster.intersectObjects(objectsToTest1)
      const intersects2 = this.raycaster.intersectObjects(objectsToTest2)

      // interset0
      if (intersects0.length) {
        console.log('object')
        if (!this.currentIntersect0) {
          intersects0[0].object.material.color.set(0xf00000)
          document.querySelector('.img-hover0').style.opacity = 1
        }

        this.currentIntersect0 = intersects0[0]
      } else {
        if (this.currentIntersect0) {
          this.currentIntersect0.object.material.color.set(0xfffff0)
          document.querySelector('.img-hover0').style.opacity = 0
        }
        this.currentIntersect0 = null
      }

      // intersect1
      if (intersects1.length) {
        console.log('object')
        if (!this.currentIntersect1) {
          intersects1[0].object.material.color.set(0xf00000)
          document.querySelector('.img-hover1').style.opacity = 1
        }

        this.currentIntersect1 = intersects1[0]
      } else {
        if (this.currentIntersect1) {
          this.currentIntersect1.object.material.color.set(0xfffff0)
          document.querySelector('.img-hover1').style.opacity = 0
        }
        this.currentIntersect1 = null
      }

      // intersect2
      if (intersects2.length) {
        console.log('object')
        if (!this.currentIntersect2) {
          intersects2[0].object.material.color.set(0xf00000)
          document.querySelector('.img-hover2').style.opacity = 1
        }

        this.currentIntersect2 = intersects2[0]
      } else {
        if (this.currentIntersect2) {
          this.currentIntersect2.object.material.color.set(0xfffff0)
          document.querySelector('.img-hover2').style.opacity = 0
        }
        this.currentIntersect2 = null
      }
    })
  };

  update () {
    if (this.fox) this.fox.update()
    if (this.vortex) this.vortex.update()
    if (this.sphere1) this.sphere1.update()
    if (this.sphere2) this.sphere2.update()
    if (this.sphere3) this.sphere3.update()
    if (this.PointLight) this.PointLight.update()
  }
}
